import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactTyped } from "react-typed";
import { FormProvider, useForm } from "react-hook-form";
import miscService from "../../../api/misc/misc";
import { Icon } from "../../../components/Component";
import FormInput from "../../form-components/InputComponent";
import { nanoid } from "nanoid";
import dayjs from "dayjs";
import purchaseRequestApis from "../../../api/master/purchaseRequest";
import quotationApis from "../../../api/master/quotations";
import deliveryAddressApis from "../../../api/master/deliveryAddress";
import ExportToXlsx from "../../../utils/exportToXlsx";
import purchaseOrderApis from "../../../api/master/PurchaseOrder";
import { TAX_SLAP_DROPDOWN } from "../../purchase-orders/EditPOMaterialModal";
import invoiceApis from "../../../api/Invoice/invoice";
const blobUrl: String = process.env.REACT_APP_BLOB_URL || "";
const blobContainer: String = process.env.REACT_APP_BLOB_CONTAINER || "";
const Configuration: any = {
  "add-new-purchase-request": {
    title: "Bulk Material Upload",
    requestType: "purchaseRequestCreate",
  },
  "rfq-creation": {
    title: "Bulk Material Upload",
    requestType: "rfqCreation",
  },
  "po-creation": {
    title: "Bulk Material Upload",
    requestType: "poCreation",
  },
  "quot-material-list": {
    title: "Bulk Material Upload",
    requestType: "quotMaterialList",
  },
  "order-to-invoice": {
    title: "Bulk Material Upload",
    requestType: "orderToInvoice",
  },
};

const BulkMaterialUpload = ({
  moduleKey,
  append,
  extra,
}: {
  moduleKey?: any;
  append?: any;
  extra?: any;
}) => {
  const [deliveryAddressList, setDeliveryAddressList] = useState([]);
  const [materials, setMaterials] = useState<any>([]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blockEdit, setBlockEdit] = useState(false);
  const [response, setResponse] = useState({
    status: "",
    message: "",
  });

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = methods;
  const files = watch("attachment");

  useEffect(() => {
    setResponse({ status: "", message: "" });
  }, [files]);

  const [showModal, setShowModal] = useState(false);
  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((address: any) => {
          const {
            id,
            deliveryLocationName,
            city,
            addressLine1,
            addressLine2,
            pincode,
            countryName,
            stateName,
            districtName,
          } = address;
          return {
            Id: id,
            deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            districtName,
            stateName,
            countryName,
            pincode,
          };
        });

        setDeliveryAddressList(deliveryAddressOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchMaterialList = async () => {
    try {
      const { data, status } = await miscService.fetchProductFiltered();
      if (status) {
        const materialOption = data.map((item: any) => ({
          "Category Name": item?.categoryName,
          materialName: item?.productName,
          materialId: item?.materialID?.toString(),
        }));
        setMaterials(materialOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMaterialList();
    fetchDeliveryAddress();
  }, [moduleKey]);

  const handleUpload = async () => {
    try {
      const attachment = files;
      if (!attachment || !attachment[0]) {
        setResponse({
          status: "error",
          message: "Please select a file",
        });
        setBlockEdit(false);
        setLoading(false);
        return;
      }
      uploadFile(
        attachment,
        moduleKey,
        setResponse,
        "File Uploaded Successfully"
      );
    } catch (error) {}
  };

  const uploadFile = async (
    attachment: any,
    moduleKey: string,
    setResponse: any,
    successResponse: any
  ) => {
    try {
      const _file = attachment?.[0];
      const formData: any = new FormData();
      formData.append("files", _file);
      let request: any;
      if (moduleKey == "po-creation") {
        request = {
          deliveryDateType: extra?.formData?.needByDateType || "Order Level",
          deliveryLevelType:
            extra?.formData?.deliveryAddressType || "Order Level",
          igstFlag: extra?.formData?.igstFlag,
        };
        let lines: any = [];
        extra?.fields?.forEach((item: any) => {
          let obj: {
            materialId: number;
            categoryId: number;
            quantity?: number;
            uomId?: number;
            deliveryDate?: any;
            deliveryAddressId?: Number;
          } = {
            materialId: Number(item?.materialName),
            categoryId: Number(item?.materialCategory),
          };
          if (item?.quantity) obj.quantity = Number(item?.quantity);
          if (item?.uomId) obj.uomId = Number(item?.uomId);
          if (extra?.formData?.deliveryAddressType == "Line Level")
            obj.deliveryAddressId = Number(item?.deliveryAddressId);

          if (extra?.formData?.needByDateType == "Line Level")
            obj.deliveryDate = dayjs(item?.needByDate).format("DD-MMM-YYYY");

          lines.push(obj);
        });
        request.lines = lines;
      } else if (moduleKey == "order-to-invoice") {
        request = extra;
      } else {
        request = {
          deliveryLevelType:
            extra?.formData?.deliveryAddressType || "ORDER_LEVEL",
          deliveryDateType: extra?.formData?.needByDateType || "ORDER_LEVEL",
        };
        let lines: any = [];
        extra?.fields?.forEach((item: any) => {
          let obj: {
            materialId: number;
            categoryId: number;
            quantity?: number;
            uomId?: number;
            deliveryDate?: any;
            deliveryAddressId?: Number;
          } = {
            materialId: Number(item?.materialName),
            categoryId: Number(item?.materialCategory),
          };
          if (item?.quantity) obj.quantity = Number(item?.quantity);
          if (item?.uomId) obj.uomId = Number(item?.uomId);
          if (extra?.formData?.deliveryAddressType == "LINE_LEVEL")
            obj.deliveryAddressId = Number(item?.deliveryAddressId);

          if (extra?.formData?.needByDateType == "LINE_LEVEL")
            obj.deliveryDate = dayjs(item?.needByDate).format("DD-MMM-YYYY");

          lines.push(obj);
        });
        request.lines = lines;
      }

      if (moduleKey == "quot-material-list") request = { ...extra };

      formData.append("request", JSON.stringify(request));
      let res;
      switch (moduleKey) {
        case "add-new-purchase-request":
          res = await purchaseRequestApis.materialBulkUploadCreate(formData);
          break;
        case "rfq-creation":
          res = await quotationApis.materialBulkUploadCreate(formData);
          break;
        case "po-creation":
          res = await purchaseOrderApis.orderMaterialBulkUpload(formData);
          break;
        case "order-to-invoice":
          res = await invoiceApis.bulkUploadInvoiceMaterials(formData);
          break;
        case "quot-material-list":
          res = await quotationApis.rfqPriceBulkUpload(formData);
          break;
        default:
      }
      const { status, error, message, response: data } = res || {};
      if (status) {
        setResponse({
          status: "success",
          message: successResponse,
        });
        if (moduleKey == "quot-material-list") {
          append({
            ...data,
          });
        } else if (moduleKey == "order-to-invoice") {
          append(data);
        } else if (moduleKey == "po-creation") {
          try {
            const { lines } = data || [];
            lines?.forEach((line: any) => {
              const igstValue = TAX_SLAP_DROPDOWN?.find(
                (dropdownItem) =>
                  dropdownItem?.label == line?.igstPercentage + "%"
              )?.value;
              const gst = TAX_SLAP_DROPDOWN?.find((dropdownItem) => {
                // console.log(Number(line?.cgstPercentage + line?.sgstPercentage)," == ", dropdownItem?.label);

                return (
                  dropdownItem?.label ==
                  Number(line?.cgstPercentage + line?.sgstPercentage) + "%"
                );
              })?.value;
              const sgstValue = gst;
              const cgstValue = gst;
              append({
                key: nanoid(),
                materialCategory: line?.categoryId?.toString(),
                materialName: line?.materialId?.toString(),
                materialLabel: line?.materialName,
                hsnCode: line?.hsnCode,
                quantity: line?.quantity,
                unitPrice: line?.unitPrice,
                uomId: line?.uomId,
                uomLabel: line?.uomName,
                amount:
                  Number(line?.unitPrice || 0) * Number(line?.quantity || 0),
                description: line?.description,
                igst: igstValue,
                igstPercentage: line?.igstPercentage,
                igstAmount: line?.igstAmount,
                cgst: cgstValue,
                cgstPercentage: line?.cgstPercentage,
                cgstAmount: line?.cgstAmount,
                sgst: sgstValue,
                sgstPercentage: line?.sgstPercentage,
                sgstAmount: line?.sgstAmount,
                cess: [],
                lineTotal: line?.lineTotal,
                attachment: false,
                errorMessage: line?.errorMessage,
                errorFlag: line?.errorFlag,
                needByDate: dayjs(line?.needByDate),
                deliveryAddressId: line?.deliveryAddressId?.toString(),
              });
            });
          } catch (error) {
            console.log("error While creating PO", error);
          }
        } else {
          const { lines } = data || [];
          lines?.forEach((item: any) => {
            const {
              materialId: materialName,
              materialName: materialLabel,
              categoryId: materialCategory,
              categoryName: categoryLabel,
              quantity,
              specification,
              errorFlag,
              errorMessage,
              remarks,
              uomId,
              uomName: uomLabel,
            } = item;
            let obj: any = {
              key: nanoid(),
              materialCategory,
              categoryLabel,
              materialName,
              materialLabel,
              quantity,
              specification,
              remarks,
              uomId,
              uomLabel,
              errorFlag,
              errorMessage,
            };
            if (extra?.formData?.deliveryAddressType == "LINE_LEVEL")
              obj.deliveryAddressId = item?.deliveryAddressId;
            if (extra?.formData?.needByDateType == "LINE_LEVEL")
              obj.needByDate = dayjs(item?.deliveryDate);
            append(obj);
          });
        }
        return;
      }
      setResponse({
        status: "error",
        message: error + ": " + message,
      });
      setBlockEdit(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const ModalContent = ({ moduleKey }: any) => {
    switch (moduleKey) {
      case "order-to-invoice":
        return (
          <>
            <p>
              You're about to submit a invoice for multiple materials. To ensure
              a smooth import, please upload the file below.
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> Do not modify column names or any
              existing data. All fields in the template are mandatory.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "quot-material-list":
        return (
          <>
            <p>
              You're about to submit a quotation for multiple materials. To
              ensure a smooth import, please upload the file below.
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> Do not modify column names or any
              existing data. All fields in the template are mandatory.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "add-new-purchase-request":
        return (
          <>
            <p>
              You're about to create multiple Lines of Materials at once. To
              ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/PR-Material-Bulk-Upload.xlsx#`}
                target="_self"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  ExportToXlsx(materials, "Materials");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each record must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "rfq-creation":
        const { deliveryAddressType, needByDateType } = extra?.formData;

        let url = `${blobUrl}${blobContainer}/RFQBulkUpload.xl`;
        if (deliveryAddressType == "LINE_LEVEL") {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithID.xl`;
        }
        if (needByDateType == "LINE_LEVEL") {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithDate.xl`;
        }
        if (
          deliveryAddressType == "LINE_LEVEL" &&
          needByDateType == "LINE_LEVEL"
        ) {
          url = `${blobUrl}${blobContainer}/RFQBulkUploadWithDateAndID.xl`;
        }

        return (
          <>
            <p>
              You're about to create multiple supplier records at once. To
              ensure a smooth import, please{" "}
              <a
                href={url}
                target="_self"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  ExportToXlsx(deliveryAddressList, "Addresses");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Addresses List
              </a>{" "}
              and{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  ExportToXlsx(materials, "Materials");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each record must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "po-creation":
        const {
          deliveryAddressType: _deliveryAddressType,
          needByDateType: _needByDateType,
          igstFlag: _hasIgst,
        } = extra?.formData;

        let _url = `${blobUrl}${blobContainer}/POUpload.xlsx`;
        if (_hasIgst) _url = `${blobUrl}${blobContainer}/POUploadWithIgst.xlsx`;

        if (_deliveryAddressType == "Line Level" && !_hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMulitpleAddress.xlsx`;

        if (_deliveryAddressType == "Line Level" && _hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleAddressWithIgst.xlsx`;

        if (_needByDateType == "Line Level" && !_hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDates.xlsx`;

        if (_needByDateType == "Line Level" && _hasIgst)
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesWithIgst.xlsx`;

        if (
          _deliveryAddressType == "Line Level" &&
          _needByDateType == "Line Level" &&
          !_hasIgst
        )
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesAddress.xlsx`;

        if (
          _deliveryAddressType == "Line Level" &&
          _needByDateType == "Line Level" &&
          _hasIgst
        )
          _url = `${blobUrl}${blobContainer}/POUploadMultipleDatesAddressWithIgst.xlsx`;
        return (
          <>
            <p>
              You're about to create multiple Lines of Materials at once. To
              ensure a smooth import, please{" "}
              <a
                href={_url}
                target="_self"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  ExportToXlsx(deliveryAddressList, "Addresses");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Addresses List
              </a>{" "}
              and{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  ExportToXlsx(materials, "Materials");
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong> All fields in the template are mandatory.
              Each record must have unique information to avoid errors during
              the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      default:
        <></>;
    }
    return <></>;
  };

  return (
    <>
      <UncontrolledDropdown size={"md"}>
        {" "}
        <div
          onClick={() => {
            setShowModal(true);
          }}
          className="btn btn-white btn-outline-light"
        >
          <Icon name="upload-cloud"></Icon>
          <span>Import</span>
        </div>
      </UncontrolledDropdown>

      <Modal
        title={Configuration[moduleKey]?.title}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
          setBlockEdit(false);
          // methods.reset()
          setValue("attachment", null);
          setLoading(false);
          setResponse(() => ({
            status: "",
            message: "",
          }));
        }}
        width={"60%"}
      >
        <FormProvider {...methods}>
          <form>
            <ModalContent moduleKey={moduleKey} />
            <Alert
              isOpen={response?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response?.message}, You can{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    setShowModal(false);
                    setBlockEdit(false);
                    // methods.reset();
                    setValue("attachment", null);
                    setLoading(false);
                    setResponse(() => ({
                      status: "",
                      message: "",
                    }));
                  }}
                >
                  close
                </span>{" "}
                this popup
              </p>
            </Alert>

            <Row className="mt-4">
              <Col>
                {response?.status == "success" ? (
                  <></>
                ) : (
                  <ul className="actions clearfix d-flex">
                    <li>
                      {loading ? (
                        <Button color="primary" type="button" size="md">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          type="button"
                          disabled={!files?.[0]}
                          onClick={() => {
                            setResponse(() => ({
                              status: "",
                              message: "",
                            }));
                            setBlockEdit(true);
                            setLoading(true);
                            handleUpload();
                          }}
                        >
                          Upload
                        </Button>
                      )}
                    </li>
                    {!loading && (
                      <li className="m-3 mt-0">
                        <Button
                          color="primary"
                          onClick={() => {
                            setShowModal(false);
                            // methods.reset();
                            setValue("attachment", null);
                          }}
                          className="btn-dim btn btn-secondary"
                        >
                          Cancel
                        </Button>
                      </li>
                    )}
                  </ul>
                )}
              </Col>
            </Row>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default BulkMaterialUpload;
